export const PRIVACY_LINK = 'https://www.dhm.de/datenschutz';
